import React, { FC, ReactNode } from 'react'
import { tokens } from '@getgo/chameleon-core/next/goto-admin'
import { AlertOutlinedIcon, CheckmarkOutlinedIcon, InfoOutlinedIcon } from '@getgo/chameleon-icons/react'
import { Box, makeStyles } from '@material-ui/core'
import { SnackbarProvider as Notistack } from 'notistack'

const useStyles = makeStyles(() => ({
  variantInfo: {
    backgroundColor: tokens.surfaceColorBrandDefault,
  },
  anchorOriginBottomLeft: {
    maxWidth: 480,
  },
  root: {
    margin: `${tokens.spacing01} 0 0 0`,
    pointerEvents: 'all', // see https://github.com/iamhosseindhv/notistack/issues/394
  },
}))

interface SnackbarProviderProps {
  children: ReactNode
}

// Provides the snackbars throughout the application
const SnackbarProvider: FC<SnackbarProviderProps> = ({ children }) => {
  const classes = useStyles()

  return (
    <Notistack
      classes={classes}
      iconVariant={{
        info: (
          <Box position="relative" top={3} mr={2}>
            <InfoOutlinedIcon />
          </Box>
        ),
        success: (
          <Box position="relative" top={3} mr={2}>
            <CheckmarkOutlinedIcon />
          </Box>
        ),
        error: (
          <Box position="relative" top={2} mr={2}>
            <AlertOutlinedIcon />
          </Box>
        ),
      }}
    >
      {children}
    </Notistack>
  )
}

export default SnackbarProvider
